<template>
  <div class="content_box">
    <div>
      <van-cell-group>
        <van-cell>
          <van-field v-model="phoneNumber" type="tel" label="手机号" placeholder="请输入手机号" />
        </van-cell>
        <van-cell>
          <van-field v-model="code" center clearable label="短信验证码" placeholder="请输入短信验证码">
            <template #button>
              <van-button v-if="show" @click="sendCodeBeforeResetPassword" size="small" type="primary">发送验证码</van-button>
              <div v-else>{{times}}s</div>
            </template>
          </van-field>
        </van-cell>
        <van-cell>
          <van-field v-model="password" type="password" label="密码" placeholder="请输入密码" />
        </van-cell>
        <van-cell>
          <van-field v-model="repassword" type="password" label="确认密码" placeholder="请输入确认密码" />
        </van-cell>
      </van-cell-group>

      <div style="padding:0.5rem">
        <van-button @click="resertPwd" type="primary" block>立即重置</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { sendCodeBeforeResetPassword, resetPassword } from "@/api/user.js";
import Vue from "vue";
import { Field } from "vant";
import { Cell, CellGroup, Button } from "vant";
import { Notify } from "vant";
import { setToken, getToken } from "@/libs/util.js";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(Button);
export default {
  data() {
    return {
      code: "",
      times: 60,
      show: true,
      password: "",
      repassword: "",
      loginStatus: true,
      phoneNumber: ""
    };
  },
  methods: {
    resertPwd() {
      if (!this.phoneNumber) {
        Notify({ type: "danger", message: "请先输入手机号！" });
        return;
      }
      if (!this.isPoneAvailable(this.phoneNumber)) {
        Notify({ type: "danger", message: "请输入合法的手机号！" });
        return;
      }
      if (!this.code) {
        Notify({ type: "danger", message: "请先获取手机验证码！" });
        return;
      }
      if (!this.password.length > 5) {
        Notify({
          type: "danger",
          message: "请输入密码,且密码长度不能小于六位！"
        });
        return;
      }
      if (!this.repassword.length > 5) {
        Notify({
          type: "danger",
          message: "请输入确认密码,且密码长度不能小于六位！"
        });
        return;
      }
      if (this.repassword !== this.password) {
        Notify({
          type: "danger",
          message: "两次密码输入不一致！"
        });
        return;
      }
      let pwdObj = {
        phoneNumber: this.phoneNumber,
        password: this.password,
        repassword: this.repassword,
        code: this.code
      };

      resetPassword(pwdObj).then(res => {
        if (res.data.status == 200) {
          Notify({
            type: "success",
            message: "密码重置成功"
          });
          this.$router.push({
            path: `/tcmr/user`
          });
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
    },
    getCode() {
      this.show = false;
      this.timer = setInterval(() => {
        this.times--;
        if (this.times === 0) {
          this.times = 60;
          this.show = true;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    isPoneAvailable(pone) {
      var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!myreg.test(pone)) {
        return false;
      } else {
        return true;
      }
    },
    sendCodeBeforeResetPassword() {
      if (this.phoneNumber) {
        sendCodeBeforeResetPassword(this.phoneNumber).then(res => {
          if (res.data.status == 200) {
            this.getCode();
            Notify({ type: "success", message: "验证码发送成功！" });
          } else {
            Notify({ type: "danger", message: res.data.msg });
          }
        });
      } else {
        Notify({ type: "danger", message: "请先输入手机号！" });
      }
    }
  }
};
</script>

<style>
</style>